"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const FormatDiskWarning = ({ someDisksAreSkipFormatting }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.Alert, { variant: react_core_1.AlertVariant.warning, "data-testid": "alert-format-bootable-disks", isInline: true, title: someDisksAreSkipFormatting
            ? t('ai:There may be issues with the boot order')
            : t('ai:All bootable disks, except for read-only disks, will be formatted during installation. Make sure to back up any sensitive data before proceeding.') }, someDisksAreSkipFormatting
        ? t('ai:You have opted out of formatting bootable disks on some hosts. To ensure the hosts reboot into the expected installation disk, manual user intervention may be required during OpenShift installation.')
        : ''));
};
exports.default = FormatDiskWarning;
//# sourceMappingURL=FormatDiskWarning.js.map